/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GenerateInvoicesRequest
 */
export interface GenerateInvoicesRequest {
    /**
     * 
     * @type {Date}
     * @memberof GenerateInvoicesRequest
     */
    invoiceDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof GenerateInvoicesRequest
     */
    billingDate: Date;
}

/**
 * Check if a given object implements the GenerateInvoicesRequest interface.
 */
export function instanceOfGenerateInvoicesRequest(value: object): value is GenerateInvoicesRequest {
    if (!('invoiceDate' in value) || value['invoiceDate'] === undefined) return false;
    if (!('billingDate' in value) || value['billingDate'] === undefined) return false;
    return true;
}

export function GenerateInvoicesRequestFromJSON(json: any): GenerateInvoicesRequest {
    return GenerateInvoicesRequestFromJSONTyped(json, false);
}

export function GenerateInvoicesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateInvoicesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'invoiceDate': (new Date(json['invoiceDate'])),
        'billingDate': (new Date(json['billingDate'])),
    };
}

export function GenerateInvoicesRequestToJSON(json: any): GenerateInvoicesRequest {
    return GenerateInvoicesRequestToJSONTyped(json, false);
}

export function GenerateInvoicesRequestToJSONTyped(value?: GenerateInvoicesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invoiceDate': value['invoiceDate'].toISOString().substring(0,10),
        'billingDate': value['billingDate'].toISOString().substring(0,10),
    };
}

